/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const incidentTypeEnum = {
    ActionableObservation: 'ActionableObservation',
    CapacityPerformance: 'CapacityPerformance',
    ChangeOrConfigurationError: 'ChangeOrConfigurationError',
    ChemicalSpillEmissions: 'ChemicalSpillEmissions',
    CoolingHVAC: 'CoolingHVAC',
    CustomerSatisfaction: 'CustomerSatisfaction',
    FacilityInfrastructure: 'FacilityInfrastructure',
    FireExplosion: 'FireExplosion',
    ITSystemsNetwork: 'ITSystemsNetwork',
    InformationSecurityCybersecurity: 'InformationSecurityCybersecurity',
    LegalRegulatory: 'LegalRegulatory',
    NetworkInfrastructure: 'NetworkInfrastructure',
    PeopleIncident: 'PeopleIncident',
    PhysicalInfrastructure: 'PhysicalInfrastructure',
    PhysicalSecurity: 'PhysicalSecurity',
    PolicyCompliance: 'PolicyCompliance',
    PositiveObservation: 'PositiveObservation',
    PowerElectricalSystems: 'PowerElectricalSystems',
    ServiceQualityContractualDeviation: 'ServiceQualityContractualDeviation',
    SupplierPerformance: 'SupplierPerformance',
    ThirdParty: 'ThirdParty',
    WasteManagement: 'WasteManagement',
} as const;

export type IncidentTypeEnumKey = (typeof incidentTypeEnum)[keyof typeof incidentTypeEnum];

export type IncidentType = IncidentTypeEnumKey;
